// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricing-container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
    font-family: 'Inter', sans-serif;
  }
  
  .pricing-container h1 {
    color: #0047AB;
    text-align: center;
    margin-bottom: 40px;
  }
  
  .pricing-plans {
    display: flex;
    justify-content: center;
    gap: 40px;
  }
  
  .pricing-plan {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 30px;
    width: 300px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .pricing-plan h2 {
    color: #00C39A;
    margin-bottom: 10px;
  }
  
  .price {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  .pricing-plan ul {
    list-style-type: none;
    padding: 0;
    margin-bottom: 30px;
  }
  
  .pricing-plan li {
    margin-bottom: 10px;
  }
  
  .plan-button {
    background-color: #00C39A;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;
  }
  
  .plan-button:hover {
    background-color: #00A67E;
  }
  
  .featured {
    border: 2px solid #00C39A;
    transform: scale(1.05);
  }
  
  .promotion-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
    text-align: center;
  }

  .promotion-section h3 {
    margin-bottom: 10px;
    color: #0047AB;
  }

  .promotion-section input {
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 10px;
    width: 200px;
    margin-right: 10px;
  }

  .promotion-section button {
    padding: 10px 20px;
    background-color: #00C39A;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s;
  }

  .promotion-section button:hover {
    background-color: #00A67E;
  }

  .message {
    text-align: center;
    margin-top: 20px;
    font-weight: bold;
    color: #0047AB;
  }`, "",{"version":3,"sources":["webpack://./src/components/Pricing.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,wCAAwC;EAC1C;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB","sourcesContent":[".pricing-container {\n    max-width: 1000px;\n    margin: 0 auto;\n    padding: 20px;\n    font-family: 'Inter', sans-serif;\n  }\n  \n  .pricing-container h1 {\n    color: #0047AB;\n    text-align: center;\n    margin-bottom: 40px;\n  }\n  \n  .pricing-plans {\n    display: flex;\n    justify-content: center;\n    gap: 40px;\n  }\n  \n  .pricing-plan {\n    background-color: #ffffff;\n    border-radius: 8px;\n    padding: 30px;\n    width: 300px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .pricing-plan h2 {\n    color: #00C39A;\n    margin-bottom: 10px;\n  }\n  \n  .price {\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 20px;\n  }\n  \n  .pricing-plan ul {\n    list-style-type: none;\n    padding: 0;\n    margin-bottom: 30px;\n  }\n  \n  .pricing-plan li {\n    margin-bottom: 10px;\n  }\n  \n  .plan-button {\n    background-color: #00C39A;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background-color 0.3s;\n  }\n  \n  .plan-button:hover {\n    background-color: #00A67E;\n  }\n  \n  .featured {\n    border: 2px solid #00C39A;\n    transform: scale(1.05);\n  }\n  \n  .promotion-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 30px;\n    text-align: center;\n  }\n\n  .promotion-section h3 {\n    margin-bottom: 10px;\n    color: #0047AB;\n  }\n\n  .promotion-section input {\n    padding: 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    margin-bottom: 10px;\n    width: 200px;\n    margin-right: 10px;\n  }\n\n  .promotion-section button {\n    padding: 10px 20px;\n    background-color: #00C39A;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background-color 0.3s;\n  }\n\n  .promotion-section button:hover {\n    background-color: #00A67E;\n  }\n\n  .message {\n    text-align: center;\n    margin-top: 20px;\n    font-weight: bold;\n    color: #0047AB;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
